import { render, staticRenderFns } from "./HolidayAssignmentGrid.vue?vue&type=template&id=2139a587"
import script from "./HolidayAssignmentGrid.vue?vue&type=script&lang=js"
export * from "./HolidayAssignmentGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports